
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";

import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import Kur from "@/components/inputs/Kur.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import MtsAlacakFormWizard from "@/components/forms/form-wizard/alacak/MtsAlacakFormWizard.vue";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";

import { ParaBirimi } from "@/enum/ParaBirimi";
import { DovizTakipSekli } from "@/enum/DovizTakipSekli";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import { TakipTarihliKurEntity } from "@/entity/TakipTarihliKurEntity";
import { takipteKdvAlaniniGoster } from "@/helpers/TakipTipiEskiNoHelper";

@Component({
  components: {
    FormDialog, DeleteDialog,
    DovizTakipSekliPicker, Kur,
    MtsAlacakFormWizard,
    ParaBirimiPicker, Tutar, Dates,
    ProtestoIhtarForm,
    AsilAlacakKalemiForm,
    AyEkleForm,
  },
})
export default class MtsAlacakForm extends mixins(ObjectInputMixin) {
  @Prop() errorAlacakKalemleri!: boolean;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop() mtsDurumu!: boolean;
  @Prop({ default: () => ({}) }) alacakDetay!: any;
  @Prop({ default: () => [] }) alacakKalemleri!: any[];
  @Prop({ default: () => [] }) ihtarlar!: any[];
  @Prop({required: false}) takipTipiEskiNo?: string | number;

  get kdvAlaniniGoster(): boolean {
    return takipteKdvAlaniniGoster(this.takipTipiEskiNo);
  }

  isWizardComplete = false;
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  alacakKalemiDetayData: any = {};
  faizTurleri:any[] =  [];

  async getFaizTurleri(){
    let response = await this.$helper.requestWithCache("/api/v1/faiz-turu/?takibe_ozel_mi=false");
    this.faizTurleri = response.data;
  }

  getTakipOncesiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_oncesi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  getTakipSonrasiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_sonrasi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  // Tek tanım — localStorage'dan cache varsa al
  paraBirimleri: any = JSON.parse(
      localStorage.getItem('ICW_CACHE::42a43ec56962ef31f9efc5f1649c2a1249aa0e1b') || '{}'
  ).data || [];

  headers = [
    { text: 'Alacak Kalemi Türü', value: 'alacak_kalemi_alani' },
    { text: 'Açıklama', value: 'aciklama' },
    { text: 'Faiz B. Tarihi', value: 'faiz_baslangic_tarihi' },
    { text: 'Takip Öncesi Faiz', value: 'takip_oncesi_faiz_turu' },
    { text: 'Takip Sonrası Faiz', value: 'takip_sonrasi_faiz_turu' },
    { text: 'Tutar', value: 'tutar' },
    { text: 'İşlemler', value: 'actions' },
  ];

  ihtarHeaders = [
    { text: 'Tarih', value: 'tarih' },
    { text: 'Tutar', value: 'tutar' },
    { text: 'Noter', value: 'noter' },
    { text: 'İşlemler', value: 'actions' },
  ];
  localValue: any;

  // ✨ tek kaynak: yeni kayıtta staging, editte server verisi
  get gridItems() {
    if (this.localValue?.id) {
      return (this.alacakKalemleri && this.alacakKalemleri.length
          ? this.alacakKalemleri
          : (this.localValue.alacak_kalemleri || []));
    }
    return this.localValue?.asil_alacaklar || [];
  }

  onStagedKalem(kalem: any) {
    if (!this.localValue.asil_alacaklar) this.$set(this.localValue, 'asil_alacaklar', []);
    this.localValue.asil_alacaklar.push(kalem);
  }

  getParaBirimiSembol(paraBirimiId: number) {
    const p: any = this.paraBirimleri.find((x: any) => x.id === paraBirimiId);
    return p ? p.kisa_isim : '';
  }

  onAdd() {
    if (this.localValue.id) this.$emit('addAlacakKalemi');
  }

  onAddIhtar() {
    if (this.localValue.id) this.$emit('addIhtar');
  }

  addAsilAlacak(item: any) {
    if (!this.localValue.id) {
      this.onStagedKalem(item);
    } else {
      this.onAdd();
    }
  }

  updateAsilAlacak(updatedItem: any, index: number) {
    if (this.localValue.id) {
      this.$emit('addAlacakKalemi');
    } else {
      this.$set(this.localValue.asil_alacaklar, index, updatedItem);
      this.input();
    }
  }

  addIhtar(item: any) {
    if (!this.localValue.id) {
      if (!this.localValue.ihtarlar) this.$set(this.localValue, 'ihtarlar', []);
      this.localValue.ihtarlar.push(item);
    }
  }

  updateIhtar(updatedItem: any, index: number) {
    if (!this.localValue.id) {
      this.$set(this.localValue.ihtarlar, index, updatedItem);
      this.input();
    }
  }

  alacakKalemiDetay(id: any) {
    this.$http.get('/api/v1/alacak-kalemi/' + id).then((response) => {
      this.alacakKalemiDetayData = response.data;
    });
  }

  deleteAsilAlacak(index: number) {
    if (this.localValue.id) this.$emit('delete');
    else this.localValue.asil_alacaklar.splice(index, 1);
  }

  deleteIhtar(index: number) {
    if (this.localValue.id) this.$emit('deleteIhtar');
    else this.localValue.ihtarlar.splice(index, 1);
  }

  get takipStore() {
    // TakipDetayView veya TakipEkleView'a göre doğru store'u seç
    const route = this.$route.path;
    if (route.includes('/icrapro/takip/') && !route.includes('/takip-ekle/')) {
      return 'takipDetay';
    }
    return 'takipEkle';
  }

  get takipBilgileri() {
    const storeName = this.takipStore;
    const state = this.$store.state[storeName];

    if (storeName === 'takipDetay') {
      return state?.takip?.takip_bilgileri || null;
    } else {
      return state?.item?.takip_bilgileri || null;
    }
  }

  get defaultFormValues() {
    const takipBilgileri = this.takipBilgileri;

    if (takipBilgileri && takipBilgileri.talepler && takipBilgileri.talepler[0]) {
      const takipAltTipi = takipBilgileri.talepler[0].takip_alt_tipi || {};
      return {
        takip_oncesi_faiz_turu_id: takipAltTipi.takip_oncesi_faiz_turu_id || null,
        takip_sonrasi_faiz_turu_id: takipAltTipi.takip_sonrasi_faiz_turu_id || null,
        faiz_hesap_sekli: takipAltTipi.faiz_hesap_sekli || null,
      }
    }

    return {
      takip_oncesi_faiz_turu_id: null,
      takip_sonrasi_faiz_turu_id: null,
      faiz_hesap_sekli: null,
    }
  }

  get aciklama() {
    if (!this.localValue.asil_alacaklar) this.$set(this.localValue, 'asil_alacaklar', []);
    const vade = this.localValue.asil_alacaklar[0]?.vade_tarihi;
    return vade ? `${this.$helper.tarihStr(vade)} vade tarihli bir adet mts` : '';
  }

  @Watch("aciklama")
  onAciklamaChange() {
    if (!this.localValue.id) this.localValue.aciklama = this.aciklama;
  }

  @Watch('localValue.doviz_kur_tarihi')
  onDovizTakipSekliChange() {
    this.addParaBirimi();
    this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
      if (this.localValue.para_birimi_id != this.paraBirimi.TRY &&
          this.localValue.doviz_kur_tarihi == DovizTakipSekli.vade) {
        asilAlacak.para_birimi_id = this.paraBirimi.TRY;
        asilAlacak.para_birimi = this.paraBirimleri.find((p: any) => p.id == this.paraBirimi.TRY);
      } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY &&
          this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
        asilAlacak.para_birimi_id = this.localValue.para_birimi_id;
        asilAlacak.para_birimi = this.localValue.para_birimi;
      }
    });
    this.input();
  }

  @Watch('localValue.para_birimi_id')
  onParaBirimiIdChange() { this.addParaBirimi(); }

  @Watch('localValue')
  onLocalValueChange() {
    if (!this.localValue.takip_tarihli_kurlar) {
      this.$set(this.localValue, 'takip_tarihli_kurlar', this.takipTarihliKurlar);
    }
    if (!this.localValue.asil_alacaklar) this.$set(this.localValue, 'asil_alacaklar', []);
    if (!this.localValue.ihtarlar) this.$set(this.localValue, 'ihtarlar', []);
  }

  onParaBirimiChange() {
    if (!this.localValue.asil_alacaklar) this.$set(this.localValue, 'asil_alacaklar', []);

    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      delete this.localValue.doviz_kur_tarihi;
      this.localValue.asil_alacaklar.forEach((a: AlacakKalemiEntity) => {
        a.para_birimi_id = this.paraBirimi.TRY;
        a.para_birimi = this.paraBirimleri.find((p: any) => p.id == this.paraBirimi.TRY);
      });
    } else if (this.localValue.para_birimi_id != this.paraBirimi.TRY &&
        this.localValue.doviz_kur_tarihi == DovizTakipSekli.tahsilat) {
      this.localValue.asil_alacaklar.forEach((a: AlacakKalemiEntity) => {
        a.para_birimi_id = this.localValue.para_birimi_id;
        a.para_birimi = this.localValue.para_birimi;
      });
    }
    this.addParaBirimi();
    this.input();
  }

  mounted() {
    this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;
    if (!this.localValue.asil_alacaklar) this.$set(this.localValue, 'asil_alacaklar', []);
    if (!this.localValue.ihtarlar) this.$set(this.localValue, 'ihtarlar', []);

    this.getFaizTurleri()
    this.input();
  }

  load() { this.$emit('load'); }
  loadAlacakKalemleri() { this.$emit('addAlacakKalemi'); }

  addParaBirimi() {
    if (this.localValue.takip_tarihli_kurlar &&
        this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur: any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      const kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }

  getAlacakKalemiAlaniIsim(item: any) {
    if (!item) return 'Asıl Alacak';

    // Önce item'daki alacak_kalemi_alani objesini kontrol et
    if (item.alacak_kalemi_alani && item.alacak_kalemi_alani.isim) {
      return item.alacak_kalemi_alani.isim;
    }

    // Eğer yoksa Vuex store'dan ID'ye göre çek (takipEkle veya takipDetay)
    const alanId = item.alacak_kalemi_alani_id || item.alacak_kalemi_alani?.id;
    if (alanId) {
      const alanMap = this.$store.state.takipEkle?.alacakKalemiAlanlariMap || this.$store.state.takipDetay?.alacakKalemiAlanlariMap;
      if (alanMap && alanMap[alanId]) {
        return alanMap[alanId].isim;
      }
    }

    return 'Asıl Alacak';
  }

}
